
<div style="display: flex; float: right;">
    <div>
      <button mat-button (click)="showData('add-role')"><mat-icon>add</mat-icon>Add Role</button>
    </div>
    <div>
      <button mat-button (click)="showData('role-list')"> Role List</button>
    </div>
  </div>
  
  <ng-container *ngIf="displayContent ==='role-list'">
      <div>
        <p style="color: red;">No data to Display!</p>
      </div>
  </ng-container>
  
<ng-container *ngIf="displayContent === 'add-role'">
    <div class="form-container">
        <h3>Role Info</h3>
        <form [formGroup]="roleForm" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <mat-form-field>
                    <mat-label>Role Name</mat-label>
                    <input matInput type="text" formControlName="roleName" placeholder="Role Name">
                </mat-form-field>
            </div>
            <div class="form-group">
                <mat-form-field>
                    <mat-label>Application Name</mat-label>
                    <input matInput type="text" formControlName="roleApplication" placeholder="Application Name">
                </mat-form-field>
            </div>
            <div class="form-group">
                <mat-form-field>
                    <mat-label>Role Description</mat-label>
                    <input matInput type="text" formControlName="roleDescription" placeholder="Role Description">
                </mat-form-field>
            </div>
            <div class="form-group">
                <p>Assign Resources</p>
                <div class="checkbox-group">
                    <p>APIs</p>
                    <mat-checkbox formControlName="apiAccess1">Access API 1</mat-checkbox>
                    <mat-checkbox formControlName="apiAccess2">Access API 2</mat-checkbox>
                </div>
                <div class="checkbox-group">
                    <p>Dashboards</p>
                    <mat-checkbox formControlName="dashboardAccess1">Access Dashboard 1</mat-checkbox>
                    <mat-checkbox formControlName="dashboardAccess2">Access Dashboard 2</mat-checkbox>
                </div>
                <div class="checkbox-group">
                    <p>Widgets</p>
                    <mat-checkbox formControlName="widgetAccess1">Access Widget 1</mat-checkbox>
                    <mat-checkbox formControlName="widgetAccess2">Access Widget 2</mat-checkbox>
                    <!-- Add more Widget checkboxes as needed -->
                </div>
            </div>
            
            <button type="submit" [disabled]="!roleForm.valid" class="btn btn-primary">Submit</button>
        </form>
    </div>
</ng-container>
